import { graphql, useStaticQuery } from "gatsby"

const useProductParameterGroups = () => {
  return useStaticQuery(graphql`
    query ProductParameterGroupsQuery {
      allStrapiProductParameterGroup {
        edges {
          node {
            strapiId
            name {
              key
              value_en
            }
            strapiId
            prefix
            suffix
            type
            label1
            label2
            info {
              key
            }
            parent_market {
              id
            }
            parent_enum_params {
              id
              product_parameter_group
            }
            abs_min
            abs_max
            hidden
            order
            step_size
          }
        }
      }
    }
  `)
    .allStrapiProductParameterGroup.edges.map(({ node }) => node)
    .concat([
      {
        name: { key: "PRODUCTS-AVAILABILITY-AVAILABILITY" },
        info: { key: "PRODUCTS-PRODUCT_FILTERS-AVAILABILITY-INFO" },
        strapiId: -3,
        prefix: null,
        suffix: null,
        type: "ENUM",
      },
    ])
}

export default useProductParameterGroups
